import { useQuery } from "@tanstack/react-query";
import { createContext, useContext, useEffect, useState } from "react";
import { callAvosApi } from "../../utils/useAvosApiHook";
import { Tenant } from "../SupplierPortal";

type ClientPortalContextType = {
    tenants: Tenant[];
    onTenantSelect: (tenant: Tenant) => void;
    selectedTenant?: Tenant;
    isLoading?: boolean;
    isError?: boolean;
};

const ClientPortalContext = createContext<ClientPortalContextType>({
    onTenantSelect: () => null,
    tenants: [],
});

export const ClientPortalProvider = ({ children }: { children: JSX.Element }) => {
    const [selectedTenant, setSelectedTenant] = useState<Tenant | undefined>();

    const getTenants = async () => {
        const { data } = await callAvosApi("/client-portal/tenant");
        return data;
    };

    const { data: tenants, isLoading, isError } = useQuery({ queryKey: ["tenants"], queryFn: getTenants });

    useEffect(() => {
        if (!!(tenants ?? []).length && !selectedTenant) {
            setSelectedTenant(tenants?.[0]);
        }
    }, [tenants]);

    const onTenantSelect = (tenant: Tenant) => {
        setSelectedTenant(tenant);
    };

    const value = {
        tenants,
        onTenantSelect,
        selectedTenant,
        isLoading,
        isError
    };

    return (
        <ClientPortalContext.Provider value={value}>
            {children}
        </ClientPortalContext.Provider>
    );
};

export const useClientPortal = (): ClientPortalContextType => {
    const clientPortal = useContext(ClientPortalContext);

    return clientPortal;
};
